const removeSynchronizedScreen = ({ synchronizedScreens, screenNumber }) => {
	synchronizedScreens.current = synchronizedScreens.current.filter(
		(synchronizedScreen) => synchronizedScreen.screenNumber !== screenNumber
	);
};

export default removeSynchronizedScreen;
